import React, { useState } from "react";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  Card,
  Chip,
  useMediaQuery,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import { useTheme } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listPrefmanceTrend } from "../../Redux/Slices/NewDashboardAPI/ListPrefmanceTrendSlice";
import { log } from "console";

const PerformanceTrendCard = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const listPrefmanceTrends = useAppSelector(
    (state) => state.ListPrefmanceTrendSlice
  );
  const Perfmancelist: any = listPrefmanceTrends?.data?.data;

  const trendData = Array.isArray(Perfmancelist?.trend)
    ? Perfmancelist.trend
    : [];

  const weeks = trendData.map((item: any) => `Week ${item.week}`);
  const data = trendData.map((item: any) => item?.percentage);
  const lastweek = trendData.map((item: any) => item?.compare_with_last_week);

  const lastPercentage = data[data.length - 1];
  const attemptedList = trendData.map((item: any) => item.attempted);
  const total = trendData.reduce(
    (sum: any, item: any) => sum + item.attempted,
    0
  );
  const lastIndex = data.length - 1;

  const valueLast = data[lastIndex];
  const prevValue = lastIndex > 0 ? data[lastIndex - 1] : null;

  const changelast =
    typeof valueLast === "number" &&
    typeof prevValue === "number" &&
    !isNaN(valueLast - prevValue)
      ? (valueLast - prevValue).toFixed(2)
      : null;

  console.log(changelast, "fds");

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: (params: any) => {
        const index = params[0].dataIndex;
        const week = params[0].axisValue;
        const value = data[index];
        const attempted = attemptedList[index];
        const change = lastweek[index];

        return `
       <div style="padding: 6px 10px;">
  <strong>${week}</strong><br/>
  Accuracy: <strong style="color:#0056d6;">${value}%</strong><br/>
  Questions: ${attempted}<br/>
  ${
    change !== null
      ? change >= 0
        ? `<span style="color:green;">↑ ${change}% from ${
            weeks[index - 1]
          }</span>`
        : `<span style="color:red;">↓ ${Math.abs(change)}% from ${
            weeks[index - 1]
          }</span>`
      : ""
  }
</div>

      `;
      },
      backgroundColor: "#fff",
      borderColor: "#eee",
      borderWidth: 1,
      textStyle: {
        color: "#333",
      },
      extraCssText: "box-shadow: 0px 4px 10px rgba(0,0,0,0.1);",
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      top: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: weeks,
      boundaryGap: false, // set to true for bar chart feel, false for line chart tight fit
      axisLine: { lineStyle: { color: "#888" } },
    },
    yAxis: {
      type: "value",
      name: !isMobile ? "Accuracy (%)" : "",
      nameLocation: "middle", // Puts label in the vertical center
      nameRotate: 90, // Rotates the label vertically
      nameGap: 45, // Adds space between label and axis
      nameTextStyle: {
        fontSize: 15,
        color: "#9ca3af",
      },
      min: 0,
      max: 100,
      axisLabel: {
        formatter: "{value}%",
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#eee",
        },
      },
    },
    series: [
      {
        data, // prepend 0 for starting point

        type: "line",
        smooth: true,
        symbolSize: 8,
        itemStyle: {
          color: "#1a73e8",
        },
        lineStyle: {
          color: "#1a73e8",
          width: 3,
        },
      },
    ],
  };

  const { data: listQuestions } = useAppSelector(
    (state) => state.ListDashboardPerformenceTrendSlice
  );
  const QuestionList = Array.isArray(listQuestions?.data)
    ? listQuestions?.data
        ?.filter((role) => role.Status !== false) // Filter out roles where status is false
        .map((listQuestions) => ({
          label: listQuestions?.name!,
          value: listQuestions.id,
        }))
    : [];
  const [selectedValue, setSelectedValue] = useState<null | number>(null);

  const handleChange = (event: any) => {
    const value = event.target.value;
    setSelectedValue(value === "all" ? null : value);
    dispatch(
      listPrefmanceTrend({ questiontype_id: value === "all" ? null : value })
    );
  };
  return (
    <Card
      sx={{
        p: 2,
        marginTop: "20px",
        width: "100%",
        boxShadow: "0px 2px 12px rgba(0,0,0,0.05)",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
      >
        <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "19px" }}>
          Performance Trend
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          mt={isMobile ? 1 : 0}
          sx={{ flexWrap: "wrap" }}
        >
          <Select
            size="small"
            sx={{ width: "15rem" }}
            value={selectedValue ?? "all"}
            onChange={handleChange}
          >
            <MenuItem value="all">All</MenuItem>
            {QuestionList?.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>

          <Chip
            label={`${Number(changelast ?? 0) >= 0 ? "↑" : "↓"} ${Math.abs(
              Number(changelast ?? 0)
            )}% since last week`}
            size="small"
            sx={{
              backgroundColor:
                Number(changelast ?? 0) >= 0 ? "#d9fbe3" : "#fee2e2",
              color: Number(changelast ?? 0) >= 0 ? "green" : "#991b1b",
              fontWeight: "bold",
            }}
          />
        </Box>
      </Box>

      <Box mt={2}>
        <ReactECharts
          option={option}
          style={{ width: "100%", height: "300px" }}
        />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
          Latest:{" "}
          <strong style={{ color: "black", fontSize: "14px" }}>
            {lastPercentage ? (
              <>↑ {lastPercentage}% accuracy</>
            ) : (
              <>↑ 0% accuracy</>
            )}
          </strong>{" "}
          <Typography
            component="span"
            sx={{
              color: Number(changelast ?? 0) >= 0 ? "#22c55e" : "#991b1b", // green or red
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            {Number(changelast ?? 0) >= 0 ? "↑" : "↓"}{" "}
            {Math.abs(Number(changelast ?? 0))}%
          </Typography>
        </Typography>
        <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
          {total} questions
        </Typography>
      </Box>
    </Card>
  );
};

export default PerformanceTrendCard;
